export const getAllKpis = (store: any) => store.kpisList.kpis;
export const getKpiDateRange = (store: any) => store.kpisList.kpiDateRange;
export const getFiscalYearStartsAt = (store: any) => store.kpisList.fiscalYearStartsAt;
